let instance = null;

export const setLenisInstance = lenis => {
  instance = lenis;
};

export const getLenisInstance = () => instance;
